import Component from '../../components/Component';

class Steps extends Component {
    constructor() {
        super();
    }

    render() {
        return (
            <div className="google-discover-steps">
                <div className="google-discover-steps-header">
                    <img src="/static/img/google_discover.svg" loading="lazy" alt="img" />
                    4-Step Google Discover Optimization
                </div>
                <div className="google-discover-steps-body">
                    <div className="google-discover-steps-body-item">
                        <div className="google-discover-steps-body-item-header">
                            <div className="google-discover-steps-body-item-header-img">
                                <img src="/static/img/grid-01.svg" loading="lazy" alt="img" />
                            </div>
                            <a
                                target="_blank"
                                href={`${this.props.url}/categories/`}
                                rel="noreferrer"
                            >
                                <strong>Categories</strong>
                            </a>
                        </div>
                        <div className="google-discover-steps-body-item-body">
                            Identify Top performing and striking distance categories
                        </div>
                    </div>
                    <div className="google-discover-steps-body-item">
                        <div className="google-discover-steps-body-item-header">
                            <div className="google-discover-steps-body-item-header-img">
                                <img src="/static/img/thumbs-up.svg" loading="lazy" alt="img" />
                            </div>
                            <a
                                target="_blank"
                                href={`${this.props.url}/entities/`}
                                rel="noreferrer"
                            >
                                <strong>Entities</strong>
                            </a>
                        </div>
                        <div className="google-discover-steps-body-item-body">
                            Identify Top performing and striking distance entities
                        </div>
                    </div>
                    <div className="google-discover-steps-body-item">
                        <div className="google-discover-steps-body-item-header">
                            <div className="google-discover-steps-body-item-header-img">
                                <img
                                    src="/static/img/notification-text.svg"
                                    loading="lazy"
                                    alt="img"
                                />
                            </div>
                            <a target="_blank" href={`${this.props.url}/authors/`} rel="noreferrer">
                                <strong>Authors</strong>
                            </a>
                        </div>
                        <div className="google-discover-steps-body-item-body">
                            Identify Top performing and striking distance authors
                        </div>
                    </div>
                    <div className="google-discover-steps-body-item">
                        <div className="google-discover-steps-body-item-header">
                            <div className="google-discover-steps-body-item-header-img">
                                <img
                                    src="/static/img/n_author-performance.svg"
                                    loading="lazy"
                                    alt="img"
                                />
                            </div>
                            <a
                                target="_blank"
                                href={`${this.props.url}/opportunities/recommendations/`}
                                rel="noreferrer"
                            >
                                <strong>Content Characteristics</strong>
                            </a>
                        </div>
                        <div className="google-discover-steps-body-item-body">
                            Identify top performing content characteristics
                        </div>
                    </div>
                </div>
            </div>
        );
    }
}

export default Steps;
